import { css } from "styled-components";

export const ghostTextStyle = css`
  background-color: transparent !important;
  border: 1px solid transparent;
  color: var(--text-light);
  font-weight: var(--font-weight-regular);
  line-height: var(--line-height-small);

  svg path {
    fill: transparent !important;
    stroke: var(--text-light) !important;
  }

  &:hover {
    background-color: transparent !important;
    border: 1px solid transparent !important;
    color: var(--button-ghost-text-hover) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--button-ghost-text-hover) !important;
    }
  }

  &:focus {
    outline: none !important;
    background-color: transparent !important;
    border: 1px solid transparent !important;
    color: var(--text-light) !important;

    svg path {
      fill: transparent !important;
      stroke: var(--text-light) !important;
    }
  }

  &:focus-visible {
    outline: 1px solid var(--button-ghost-focused-border) !important;
    box-shadow: 0px 0px 0px 2px var(--button-focused-shadow) !important;
  }

  &:active {
    background-color: transparent !important;
    border-color: transparent !important;
    color: var(--button-ghost-text-hover) !important;
  }

  &[disabled] {
    background-color: transparent !important;
    border: 1px solid transparent;
    color: var(--text-light) !important;
    opacity: 0.7;

    &:hover {
      background-color: transparent !important;
      border: 1px solid transparent;
      color: var(--text-light) !important;
      opacity: 0.7;

      svg path {
        fill: transparent !important;
        stroke: var(--text-light);
      }
    }
  }
`;
